'use client';

import { Button } from '@ahafood/ui/components/button';
import { MapPin } from 'lucide-react';
import { useStoreCitySheet } from '@/contexts/store-city-sheet-context';

interface AddressRequiredNoticeProps {
  /** Tên city đang duyệt, để câu chữ cụ thể thay vì chung chung. */
  cityName?: string;
  /** `section` = dải chèn giữa trang chủ. `page` = chiếm chỗ cả một trang. */
  variant?: 'section' | 'page';
}

/**
 * Dải nhắc nhập địa chỉ, thay cho các section BẮT BUỘC lat/lng (SoloMeal, gợi ý
 * cho bạn, ETA…).
 *
 * Cố ý chỉ dùng MỘT dải cho cả trang: mỗi section một lời nhắc giống hệt nhau sẽ
 * thành 4-5 lần lải nhải trên một màn hình. Trang vẫn duyệt được bằng `city_id`,
 * đây chỉ là đường dẫn để user tự bổ sung địa chỉ khi muốn xem thứ cần toạ độ.
 */
export default function AddressRequiredNotice({
  cityName,
  variant = 'section',
}: AddressRequiredNoticeProps) {
  const { openCitySheet } = useStoreCitySheet();

  const isPage = variant === 'page';

  return (
    <div
      className={
        isPage
          ? 'flex flex-col items-center justify-center gap-3 px-6 py-16 text-center'
          : 'mx-4 my-3 flex flex-col gap-3 rounded-xl border border-neutral-20 bg-neutral-10/40 p-4 sm:flex-row sm:items-center sm:justify-between'
      }
    >
      <div
        className={
          isPage ? 'flex flex-col items-center gap-2' : 'flex items-start gap-3'
        }
      >
        <MapPin className="size-5 shrink-0 text-primary-50" />
        <div className={isPage ? '' : 'min-w-0'}>
          <p className="text-base font-semibold text-neutral-90">
            Nhập địa chỉ để xem món gần bạn
          </p>
          <p className="mt-0.5 text-sm text-neutral-60">
            {cityName
              ? `Bạn đang xem ${cityName}. Thêm địa chỉ giao để biết quán nào gần và bao lâu thì tới.`
              : 'Thêm địa chỉ giao để biết quán nào gần bạn và bao lâu thì tới.'}
          </p>
        </div>
      </div>

      <Button
        type="button"
        onClick={() => openCitySheet()}
        className="shrink-0"
        data-testid="address-required-cta"
      >
        Chọn địa chỉ
      </Button>
    </div>
  );
}
